import {
  type CustomRenderer,
  type CustomCell,
  GridCellKind,
} from "@glideapps/glide-data-grid";

export const ColouredLabelRenderer: CustomRenderer<ColouredLabelCell> = {
  kind: GridCellKind.Custom,
  isMatch: (cell): cell is ColouredLabelCell =>
    (cell as ColouredLabelCell).data?.labels !== undefined,
  draw: (args, cell) => {
    const { ctx, rect } = args;
    const padding = 6;
    let x = rect.x + padding;
    const y = rect.y + rect.height / 2;

    ctx.font = "12px sans-serif";

    for (const label of cell.data.labels) {
      const text = label.text;
      const textWidth = ctx.measureText(text).width;
      const chipWidth = textWidth + 16;
      const chipHeight = 20;

      // Background
      ctx.fillStyle = label.colour;
      ctx.beginPath();
      ctx.roundRect(x, y - chipHeight / 2, chipWidth, chipHeight, 10);
      ctx.fill();

      // Text
      ctx.fillStyle = "#fff";
      ctx.fillText(text, x + 8, y + 2);

      x += chipWidth + 8;
    }

    return true; // we painted something
  },
};


export interface ColouredLabelCell extends CustomCell {
  kind: GridCellKind.Custom;
  data: {
    labels: { text: string; colour: string }[];
  };
  readonly: boolean;
}
